export default "__VITE_ASSET__D$6fe6Tt__"